import * as React from "react";

class Footer extends React.Component {

	render() {
		return (
			<footer>
				<div className="container">
					<div className="row">
						<div className="col-sm-6">
							Copyright &copy; 2022. All Rights Reserved. Powered by <a href="https://responsivedata.com" target="_blank"  rel="noopener noreferrer" >Responsive Data</a>.
						</div>
						<div className="col-sm-6 tar">
							<a href="https://www.responsivedata.com/contact" rel="noopener noreferrer" target="_blank">Contact Us</a>
						</div>
					</div>
				</div>
			</footer>
		)
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.jsx